import { initBrowserRum as _initBrowserRum } from '@smg-real-estate/browser-rum';

export const initBrowserRum = (): void => {
  _initBrowserRum({
    sessionSampleRate: 1, // 1%
    env: import.meta.env.VUE_APP_ENVIRONMENT,
    applicationId: import.meta.env.VUE_DATADOG_RUM_APPLICATION_ID,
    clientToken: import.meta.env.VUE_DATADOG_RUM_CLIENT_TOKEN,
    service: import.meta.env.VUE_APP_PLATFORM + '-favourites',
  });
};
